import {
    Button,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    makeStyles,
    IconButton,
} from "@material-ui/core";
import {
    Add,
    Edit,
    Delete,
} from "@material-ui/icons";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { db } from "../../../../firebase";
import { getItemTypesService } from "./item-types-list-service";
import ItemTypesListLoading from "./item-types-list-loading";
import ItemTypesListEmpty from "./item-types-list-empty";
import { showAddItemTypesDialog } from "../item-types-add/item-types-add-slice";
import { showEditItemTypesDialog } from "../item-types-edit/item-types-edit-slice";
import { showDeleteItemTypesDialog } from "../item-types-delete/item-types-delete-slice";
import { showErrorSnackbar } from "../../../shared/snackbar/snackbar-slice";

const useStyles = makeStyles((theme) => ({
    tableHeader: {
        background: "#111111",
        height: "100%",
        color: "#fbbbd3",
        fontSize: 14,
    },
    button: {
        background: "#111111",
        color: "#fbbbd3",
        justifyContent: "right",
        '&:hover': {
            backgroundColor: '#fbbbd3',
            color: '#111111',
        },
    },
    buttonText: {
        color: "#111111",
        '&:hover': {
            backgroundColor: '#fbbbd3',
            color: '#111111',
        },
    },
    title: {
        color:"#111111",
        marginBottom: 20,
    }
}));


const ItemTypesList = () => {
    const classes = useStyles();
    const itemTypesCollection = useSelector((state) => state.itemTypesListSlice.rows);
    const isLoading = useSelector((state) => state.itemTypesListSlice.isLoading);
    const dispatch = useDispatch();

    // get data
    useEffect(() => {
        const fetchData = async () => {
            try {
                await getItemTypesService(dispatch, db, "item_types");
            } catch(e) {
                dispatch(showErrorSnackbar("Something went wrong while trying to fetch."));
                console.error("ItemTypesList fetchData error: ", e);
            }
        }
        fetchData();
    }, [dispatch]);

    // open add dialog
    const handleAddOpen = () => {
        dispatch(showAddItemTypesDialog());
    };

    // open edit dialog
    const handleEditOpen = (row) => {
        dispatch(showEditItemTypesDialog(row));
    };

    // open delete dialog
    const handleDeleteOpen = (row) => {
        dispatch(showDeleteItemTypesDialog(row));
    };

    // return loading state if isLoading is true
    if (isLoading) {
        return <ItemTypesListLoading/>
    }

    // return empty state if isLoading is false and itemTypesCollection has no collection
    if (!isLoading && itemTypesCollection.length === 0) {
        return <ItemTypesListEmpty/>
    }

    return (
        <>
            <Typography className={classes.title} variant="h4">Item Types</Typography>
            <div style={{ display: "flex", alignItems: "center", marginBottom: 10}}>
                <Button
                    variant="contained"
                    className={classes.button}
                    startIcon={<Add/>}
                    onClick={handleAddOpen}
                >
                    Add
                </Button>
            </div>
            
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 700 }} aria-label="customized table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="left" className={classes.tableHeader}>Code</TableCell>
                            <TableCell align="left" className={classes.tableHeader}>Name</TableCell>
                            <TableCell align="left" className={classes.tableHeader}>Description</TableCell>
                            <TableCell align="left" className={classes.tableHeader}>Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {itemTypesCollection.map((row) => (
                            <TableRow key={row.code}>
                                <TableCell component="th" scope="row">
                                    {row.code}
                                </TableCell>
                                <TableCell align="right">{row.name}</TableCell>
                                <TableCell align="right">{row.description}</TableCell>
                                <TableCell align="center">
                                    <IconButton
                                        className={classes.buttonText}
                                        onClick={() => handleEditOpen(row)}
                                    >
                                        <Edit/>
                                    </IconButton>
                                    <IconButton
                                        className={classes.buttonText}
                                        onClick={() => handleDeleteOpen(row)}
                                    >
                                        <Delete/>
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    );
};

export default ItemTypesList;